module.exports = __webpack_public_path__ + "static/media/CIBSE_Ruth.559194e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/CIBSE_Ruth.jpg
// module id = 256
// module chunks = 0